import React from 'react';
import iconTemplate from './IconTemplate';

export default iconTemplate(
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2.50586 13.6426C2.71274 15.3698 4.17142 16.7148 5.90975 16.7793C6.89543 16.8158 7.90583 16.8349 9.00003 16.8349C10.0942 16.8349 11.1046 16.8158 12.0903 16.7793C13.8287 16.7148 15.2873 15.3698 15.4943 13.6426C15.574 12.9764 15.6307 12.2987 15.6307 11.6116C15.6307 10.9246 15.574 10.2469 15.4943 9.5807C15.2873 7.85352 13.8287 6.50847 12.0903 6.44396C11.1046 6.40738 10.0942 6.38843 9.00003 6.38843C7.90583 6.38843 6.89543 6.40738 5.90975 6.44396C4.17142 6.50847 2.71274 7.85352 2.50586 9.5807C2.42606 10.2469 2.36938 10.9246 2.36938 11.6116C2.36938 12.2987 2.42606 12.9764 2.50586 13.6426Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.6569 6.38849V4.82153C12.6569 3.85183 12.2718 2.92185 11.5861 2.23617C10.9004 1.55049 9.97041 1.16528 9.00072 1.16528C8.03103 1.16528 7.10105 1.55049 6.41537 2.23617C5.72969 2.92185 5.34448 3.85183 5.34448 4.82153V6.38849"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9 10.8806V12.1341"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>,
) as React.FC<{ className?: string }>;
